import { createStore } from "redux";
import { createRef } from "react";
import update from "react-addons-update";
import toastr from "toastr";
import * as axios from "axios";

const initialState = {
  isSearch: localStorage.getItem('filter') ? true:false,
  musculo: "Chest",
  apparatus: [],
  days: 5,
  ejercicios: [],
  personalPlan: [
    {
      id: 1,
      items: [],
    },
    {
      id: 2,
      items: [],
    },
    {
      id: 3,
      items: [],
    },
    {
      id: 4,
      items: [],
    },
    {
      id: 5,
      items: [],
    },
  ],
  dayIndex: 0,
  activePage: 1,
  perpage: 12,
  indexInitial: 0,
  indexLast: 11,
  planValue: 194,
  totalValue: 194,
  dietaValue: 97,
  donationValue: 3,
  customPage: parseInt(localStorage.getItem("customPage")) || 0,
  listRef: createRef(),
  muscleRef: createRef(),
  firstPageRef: createRef(),
  alertMuscle: [],
  userRestricId: parseInt(localStorage.getItem("userRestricId")) || 0
};
const maximun = {
  Forearms: 20,
  Chest: 22,
  Back: 25,
  Quadriceps: 20,
  Hamstrings: 20,
  Calves: 20,
  "Triceps Brachii": 18,
  "Trapezius": 26,
  Shoulders: 26,
  "Waist": 25,
  "Hips": 16,
  "Biceps Brachii": 26,
  "Hip Adductor": 20,
  Abductors: 20,
};

const compareMaximumSeries = (maximum, Target_Muscle_Group, plan, musculo) => {
  var ejercice = [];
  for (let i = 0; i < plan.length; i++) {
    for (let j = 0; j < plan[i].items.length; j++) {
      if (plan[i].items[j].muscle === musculo) {
        ejercice.push(plan[i].items[j]);
      }
    }
  }
  var total = 0;
  for (let i = 0; i < ejercice.length; i++) {
    total += ejercice[i].sets;
  }

  if (total >= maximum[musculo]) {
    toastr.clear();
    initialState.alertMuscle.push(Target_Muscle_Group);
    toastr.options = {
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
    toastr.warning(
      "Advertencia: El máximo de series recomendado para " +
        Target_Muscle_Group +
        " es de " +
        maximum[musculo] +
        " a la semana"
    );
  }
};
const updateWebPersonalPlan = (plan) => {
  const id = parseInt(localStorage.getItem("userRestricId")) || 0;
  if (id !== 0) {
    axios
      .post(
        "https://fullmusculo.com/api/personal_routine",
        {
          data: { user: id.toString(), content: plan },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        //console.log(res);
        localStorage.setItem("plan", JSON.stringify(res.data.result.content));
        //initialState.personalPlan = res.data.result.content;
      })
      .catch((err) => console.log(err));
  }
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SELECT_MUSCULO": {
      if (!action.scroll)
        setTimeout(()=>{
          if (state.listRef.current) {
            state.listRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        },500)

      return update(state, {
        isSearch: {$set: action.apparatus? true:false},
        musculo: {
          $set: action.musculo,
        },
        ejercicios: {
          $set: action.ejercicios,
        },
        apparatus: {
          $set: action.apparatus,
        },
        indexLast: {
          $set: 11,
        },
        indexInitial: {
          $set: 0,
        },
        activePage: {
          $set: 1,
        },
      });
    }
    case "ADD_EJERCICIO": {
      action.ejercice.muscle = state.musculo;
      state.personalPlan[state.dayIndex].items.push(action.ejercice);
      localStorage.setItem("plan", JSON.stringify(state.personalPlan));
      compareMaximumSeries(maximun, action.ejercice.Target_Muscle_Group, state.personalPlan, state.musculo);
      updateWebPersonalPlan(state.personalPlan);
      return {
        ...state,
      };
    }
    case "DELETE_EJERCICE": {
      let plan = state.personalPlan;
      plan[action.colum - 1].items.splice(action.index, 1);
      localStorage.setItem("plan", JSON.stringify(plan));
      updateWebPersonalPlan(plan);
      return update(state, {
        personalPlan: { $set: JSON.parse(localStorage.getItem("plan")) },
      });
    }
    case "SET_PLAN": {
      return { ...state, personalPlan: action.plan, days: action.plan.length };
    }
    case "COPY_EJERCICE": {
      let plan = state.personalPlan;
      plan[action.colum - 1].items.push(action.ejercice);
      localStorage.setItem("plan", JSON.stringify(plan));
      compareMaximumSeries(maximun, action.ejercice.Target_Muscle_Group, state.personalPlan, state.musculo);
      updateWebPersonalPlan(plan);
      return update(state, {
        personalPlan: { $set: JSON.parse(localStorage.getItem("plan")) },
      });
    }
    case "REDUCE_DAYS": {
      if (state.days > 1) {
        return {
          ...state,
          days: state.days - 1,
          personalPlan: state.personalPlan.slice(0, state.personalPlan.length - 1),
        };
      }
      return {
        ...state,
      };
    }
    case "ADD_DAYS": {
      if (state.days < 7) {
        return {
          ...state,
          days: state.days + 1,
          personalPlan: state.personalPlan.concat([
            {
              id: state.days + 1,
              items: [],
            },
          ]),
        };
      }
      return {
        ...state,
      };
    }
    case "PAGINATION": {
      return {
        ...state,
        indexLast: action.pageNumber * state.perpage - 1,
        indexInitial: (action.pageNumber - 1) * state.perpage,
        activePage: action.pageNumber,
      };
    }
    case "REPS": {
      let plan = state.personalPlan;
      plan[action.colum - 1].items[action.index].reps = action.value;
      localStorage.setItem("plan", JSON.stringify(plan));
      updateWebPersonalPlan(plan);
      return update(state,{
        personalPlan: {$set: JSON.parse(localStorage.getItem("plan")) }
      });
    }
    case "SETS": {
      compareMaximumSeries(
        maximun,
        state.personalPlan[action.colum - 1].items[action.index].Target_Muscle_Group,
        state.personalPlan,
          state.musculo
      );
      let plan = state.personalPlan;
      plan[action.colum - 1].items[action.index].sets = action.value;
      localStorage.setItem("plan", JSON.stringify(plan));
      updateWebPersonalPlan(plan);
      return update(state, {
        personalPlan: {$set: JSON.parse(localStorage.getItem("plan"))},
      });
    }
    case "CHAGE_PAYVALUE": {
      return update(state, {
        totalValue: {
          $set: action.value,
        },
      });
    }
    case "CHANGE_PAGE": {
      return update(state, {
        customPage: {
          $set: action.customPage,
        },
      });
    }
    case "TO_UP": {
      state.muscleRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      return {
        ...state,
      };
    }
    case "CHANGE_DAY": {
      if (action.day > -1 && action.day < state.personalPlan.length) {
        return update(state, {
          dayIndex: { $set: action.day },
        });
      } else {
        return { ...state };
      }
    }
    case "CHANGE_TO_NEXT_DAY": {
      if (state.dayIndex < state.personalPlan.length - 1) {
        let ejercice = state.personalPlan[state.dayIndex].items[action.id];
        let items = state.personalPlan[state.dayIndex].items;
        items.splice(action.id, 1);
        /* state.personalPlan[state.dayIndex + 1].items.push(ejercice) */
        let plan = state.personalPlan;
        plan[state.dayIndex].items = items;
        plan[state.dayIndex + 1].items.push(ejercice);
        localStorage.setItem("plan", JSON.stringify(plan));
        updateWebPersonalPlan(plan);
        return update(state, {
          personalPlan: { $set: JSON.parse(localStorage.getItem("plan")) },
        });
      } else {
        return { ...state };
      }
    }
    case "CHANGE_TO_PREV_DAY": {
      if (state.dayIndex > 0) {
        let ejercice = state.personalPlan[state.dayIndex].items[action.id];
        let items = state.personalPlan[state.dayIndex].items;
        items.splice(action.id, 1);
        let plan = state.personalPlan;
        plan[state.dayIndex].items = items;
        plan[state.dayIndex - 1].items.push(ejercice);
        localStorage.setItem("plan", JSON.stringify(plan));
        updateWebPersonalPlan(plan);
        /* state.personalPlan[state.dayIndex + 1].items.push(ejercice) */
        return update(state, {
          personalPlan: { $set: JSON.parse(localStorage.getItem("plan")) },
        });
      } else {
        return { ...state };
      }
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default createStore(reducer);
